/* ==========================================================================
   GemofU extras (settings come from snippets/gou-plus.liquid)
   1. Product page: "Extra 10% off with TODAY10" line under the price
     (orders above CFG.min only).
   2. Product page: "Order today, ships by <date>" (24-48 working hours,
      weekends skipped, as in the shipping policy).
   3. Product page: "Complete the look" - pieces from matching categories,
      added to the bag in one tap. Shown last in the product info column.
   4. Phones: a sticky Add to Cart bar once the main button scrolls away.
   Shared helper: GOU.addToBag(variantId) adds an item and opens the theme's
   cart drawer with the bag refreshed.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.GOU_PLUS || {};
  var GOU = window.GOU = window.GOU || {};

  /* ---- helpers ---------------------------------------------------------- */
  function money(cents) {
    // Whole rupees only (no paise): Rs. 809, not Rs. 809.10
    var n = Math.round(cents / 100);
    var s = n.toLocaleString('en-IN');
    return (CFG.moneyFormat || 'Rs. {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function cartConfig() {
    var el = document.getElementById('cart-config');
    try { return el ? JSON.parse(el.innerHTML || '{}') : null; } catch (e) { return null; }
  }
  GOU.refreshBag = function (open) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cfg = cartConfig();
        try { if (cfg && window.WAU && WAU.AjaxCart) WAU.AjaxCart.updateView(cfg, cart); } catch (e) {}
        document.querySelectorAll('.js-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        if (open) {
          try { WAU.Slideout._openByName('slideout-ajax-cart'); } catch (e) { window.location.href = '/cart'; }
        }
        return cart;
      });
  };
  GOU.addToBag = function (variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add');
        return j;
      });
    }).then(function () { return GOU.refreshBag(true); });
  };

  /* ---- Collection pages: shop-by chips -------------------------------- */
  var CHIPS = [
    ['bridal-wedding', 'Bridal & Wedding'], ['party-wear', 'Party Wear'], ['temple-ethnic', 'Temple & Ethnic'],
    ['daily-wear', 'Daily Wear'], ['office-wear', 'Office Wear'], ['handmade', 'Handmade'], ['gifting', 'Gifting'],
    ['under-699', 'Under ₹699'], ['under-999', 'Under ₹999'], ['1000-to-1999', '₹1000 – ₹1999'], ['2000-and-above', '₹2000 & Above']
  ];
  function buildChips() {
    var here = (location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1] || '';
    var host = document.querySelector('.gou-inline-search--below') || document.querySelector('#collection-page .collection-description');
    if (!host || document.querySelector('.gou-chips')) return !!host;
    var nav = document.createElement('nav');
    nav.className = 'gou-chips';
    nav.setAttribute('aria-label', 'Shop by occasion and price');
    nav.innerHTML = CHIPS.map(function (c) {
      return '<a class="gou-chips__chip' + (c[0] === here ? ' is-active' : '') + '" href="/collections/' + c[0] + '">' + esc(c[1]) + '</a>';
    }).join('');
    host.insertAdjacentElement('afterend', nav);
    var act = nav.querySelector('.is-active');
    if (act) nav.scrollLeft = act.offsetLeft - 20;
    return true;
  }
  if (CFG.template === 'collection') {
    ready(function () {
      if (buildChips()) return;
      var n = 0, t = setInterval(function () { if (buildChips() || ++n > 30) clearInterval(t); }, 200);
    });
    return;
  }

  if (CFG.template !== 'product' || !CFG.product) return;

  /* ---- product data ----------------------------------------------------- */
  var right, product, idInput;
  function variant() {
    if (!product) return null;
    var id = idInput ? String(idInput.value) : '';
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === id) return product.variants[i];
    }
    return product.variants[0];
  }

  /* ---- 1. offer line ---------------------------------------------------- */
  var offer;
  function drawOffer() {
    var v = variant();
    if (!offer || !v) return;
    var after = v.price * (100 - (CFG.percent || 10)) / 100;
    offer.hidden = !v.available;
    /* Code only works on orders of CFG.min (Rs.) or more: below that,
       say so instead of showing a price the customer cannot get. */
    var minP = (CFG.min || 0) * 100;
    var ok = v.price >= minP;
    offer.querySelector('.gou-offer__yes').hidden = !ok;
    offer.querySelector('.gou-offer__no').hidden = ok;
    offer.querySelector('.gou-offer__after').textContent = money(after);
  }
  function buildOffer() {
    var prices = right.querySelector('.product-form__prices');
    if (!prices || !CFG.code) return;
    offer = document.createElement('div');
    offer.className = 'gou-offer';
    offer.innerHTML =
      '<span class="gou-offer__tag">' + esc(CFG.percent) + '% OFF</span>' +
      '<span class="gou-offer__text"><span class="gou-offer__yes">Pay <strong class="gou-offer__after"></strong> with code</span>' +
      '<span class="gou-offer__no" hidden>On orders above <strong>' + esc(money((CFG.min || 0) * 100).replace(/\.00$/, '')) + '</strong> with code</span> ' +
      '<button type="button" class="gou-offer__code" aria-label="Copy code ' + esc(CFG.code) + '">' + esc(CFG.code) + '</button></span>';
    prices.insertAdjacentElement('afterend', offer);
    offer.querySelector('.gou-offer__code').addEventListener('click', function () {
      var b = this;
      var done = function () {
        b.classList.add('is-copied');
        b.textContent = 'Copied';
        setTimeout(function () { b.classList.remove('is-copied'); b.textContent = CFG.code; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CFG.code).then(done, done);
      else done();
    });
    drawOffer();
  }

  /* ---- 2. dispatch date ------------------------------------------------- */
  function addWorkingDays(d, n) {
    var x = new Date(d.getTime());
    /* An order placed on a weekend starts its clock on Monday morning, so
       Monday itself counts as the first working day (Sunday order: 48
       working hours = Monday + Tuesday, ships by Tuesday). */
    var moved = false;
    while (x.getDay() === 0 || x.getDay() === 6) { x.setDate(x.getDate() + 1); moved = true; }
    if (moved) n -= 1;
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (x.getDay() !== 0 && x.getDay() !== 6) n--;
    }
    return x;
  }
  function buildDispatch() {
    var form = right.querySelector('form.product__form-buttons, .product__form-buttons');
    if (!form) return;
    var ships = addWorkingDays(new Date(), 2);
    var label = ships.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    var el = document.createElement('p');
    el.className = 'gou-dispatch';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1.5 4.5h12v10h-12z"/><path d="M13.5 8.5h4l3 3v3h-7z"/><circle cx="5.5" cy="17.5" r="2"/><circle cx="17" cy="17.5" r="2"/></svg>' +
      '<span>Order today, <strong>ships by ' + esc(label) + '</strong></span>';
    form.insertAdjacentElement('afterend', el);
  }

  /* ---- 3. complete the look -------------------------------------------- */
  var PAIRS = {
    'necklace': ['earrings', 'maang-tikka', 'bangles'],
    'earrings': ['necklace', 'maang-tikka', 'rings'],
    'bangles': ['rings', 'earrings', 'bracelets'],
    'bracelets': ['rings', 'ear-studs', 'bangles'],
    'rings': ['bangles', 'ear-studs', 'bracelets'],
    'ear-studs': ['rings', 'necklace', 'bracelets'],
    'maang-tikka': ['earrings', 'necklace'],
    'mangalsutra': ['ear-studs', 'rings', 'bangles'],
    'elane': ['elane', 'ear-studs', 'rings']
  };
  var ORDER = ['mangalsutra', 'maang-tikka', 'elane', 'ear-studs', 'rings', 'bracelets', 'bangles', 'earrings', 'necklace'];
  var WORDS = ['green', 'emerald', 'red', 'ruby', 'pink', 'blue', 'white', 'black', 'maroon', 'purple',
               'peacock', 'kemp', 'pearl', 'moissanite', 'polki', 'kundan', 'temple', 'lakshmi', 'antique', 'silver', 'rose'];

  function category() {
    var cols = CFG.product.collections || [];
    for (var i = 0; i < ORDER.length; i++) if (cols.indexOf(ORDER[i]) !== -1) return ORDER[i];
    var t = (CFG.product.type || '').toLowerCase();
    for (var j = 0; j < ORDER.length; j++) if (t.indexOf(ORDER[j].replace('-', ' ')) !== -1) return ORDER[j];
    return 'necklace';
  }
  function words(s) {
    s = (s || '').toLowerCase();
    return WORDS.filter(function (w) { return s.indexOf(w) !== -1; });
  }
  function pick(list, mine, n, taken) {
    var scored = list.filter(function (p) {
      return p.handle !== CFG.product.handle && !taken[p.handle] &&
        p.variants.some(function (v) { return v.available; }) && p.images && p.images.length;
    }).map(function (p, i) {
      var w = words(p.title);
      var s = w.filter(function (x) { return mine.indexOf(x) !== -1; }).length;
      return { p: p, s: s, i: i };
    });
    scored.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    return scored.slice(0, n).map(function (o) { taken[o.p.handle] = 1; return o.p; });
  }
  function card(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0];
    var img = p.images[0].src;
    img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=300';
    var price = Math.round(parseFloat(v.price) * 100);
    return '<div class="gou-look__item">' +
      '<a class="gou-look__img" href="/products/' + esc(p.handle) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="150" height="188"></a>' +
      '<a class="gou-look__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
      '<span class="gou-look__price">' + money(price) + '</span>' +
      '<button type="button" class="gou-look__add" data-variant="' + esc(v.id) + '">Add to Cart</button>' +
      '</div>';
  }
  function buildLook() {
    // Sits at the very bottom of the product info column, after the trust block.
    var host = right.querySelector('.sticky--content') || right;
    var cat = category();
    var partners = PAIRS[cat] || PAIRS.necklace;
    var mine = words(CFG.product.title);
    Promise.all(partners.map(function (h) {
      return fetch('/collections/' + h + '/products.json?limit=40', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    })).then(function (lists) {
      var taken = {}, out = [];
      var want = [2, 1, 1];
      lists.forEach(function (l, i) { out = out.concat(pick(l, mine, want[i] || 1, taken)); });
      if (out.length < 4) lists.forEach(function (l) { if (out.length < 4) out = out.concat(pick(l, mine, 4 - out.length, taken)); });
      out = out.slice(0, 4);
      if (!out.length) return;
      var box = document.createElement('section');
      box.className = 'gou-look';
      box.setAttribute('aria-label', 'Complete the look');
      box.innerHTML = '<p class="gou-look__head">Complete the look</p><div class="gou-look__row">' + out.map(card).join('') + '</div>';
      host.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.gou-look__add') : null;
        if (!b || b.disabled) return;
        b.disabled = true;
        var old = b.textContent;
        b.textContent = 'Adding...';
        GOU.addToBag(b.getAttribute('data-variant')).then(function () {
          b.textContent = 'Added';
          b.classList.add('is-added');
          setTimeout(function () { b.disabled = false; b.textContent = old; b.classList.remove('is-added'); }, 2200);
        }).catch(function (err) {
          b.disabled = false;
          b.textContent = 'Sold out';
          setTimeout(function () { b.textContent = old; }, 2200);
        });
      });
    });
  }

  /* ---- 4. sticky Add to Cart on phones ---------------------------------- */
  function buildSticky() {
    var main = right.querySelector('.product__form-buttons .js-ajax-submit, .product__form-buttons [type="submit"]');
    if (!main || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'gou-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="gou-sticky__info"><span class="gou-sticky__title">' + esc(CFG.product.title) + '</span>' +
      '<span class="gou-sticky__price"></span></div>' +
      '<button type="button" class="gou-sticky__btn" tabindex="-1">Add to Cart</button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('.gou-sticky__btn');
    function sync() {
      var v = variant();
      bar.querySelector('.gou-sticky__price').textContent = v ? money(v.price) : '';
      var off = main.disabled || (v && !v.available);
      btn.disabled = !!off;
      btn.textContent = off ? 'Sold Out' : 'Add to Cart';
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      main.click();
    });
    var shown = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Show once the main button has scrolled up out of view.
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('gou-sticky-on', show);
    }).observe(main);
    sync();
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('#formVariantId, input[name="id"]')) setTimeout(sync, 60);
    }, true);
  }

  ready(function () {
    right = document.querySelector('.product__section-right');
    var pj = document.querySelector('script.product-json');
    try { product = pj ? JSON.parse(pj.textContent) : null; } catch (e) { product = null; }
    if (!right || !product) return;
    idInput = right.querySelector('#formVariantId') || right.querySelector('input[name="id"]');
    buildOffer();
    buildDispatch();
    buildLook();
    buildSticky();
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('#formVariantId, input[name="id"]')) setTimeout(drawOffer, 60);
    }, true);
  });
})();
